import { resolveQuestionDisplayQuery } from '../../../../components/QAInput/utils/inlineMentionLabel';
import { normalizeSerializedMentionGaps } from '../../../../components/QAInput/mentionEditor/mentionTokenDom';
import { patchCollapsedKbCountMentionMarkers } from '../../../../components/QAInput/utils/inlineMentionRanges';
import type { IEditQuestionFrontendMeta } from './types';

/**
 * 编辑态展示串唯一解析入口：优先 display_query，补全折叠态 @库名 N篇 边界符。
 */
export const resolveEditDisplayQuery = (
  meta: IEditQuestionFrontendMeta | undefined,
  question: string,
  isEN: boolean,
  kbDocUnit: string,
): string => {
  const fromApi = meta?.display_query?.trim();
  const raw = fromApi
    || resolveQuestionDisplayQuery({
      question,
      displayQuery: meta?.display_query,
      queryTabs: meta?.queryTabs,
      isSkillInherited: meta?.isSkillInherited,
      isEN,
      kbExpandToken: meta?.kb_expand_token,
    });

  return normalizeSerializedMentionGaps(
    patchCollapsedKbCountMentionMarkers(raw, kbDocUnit),
  );
};
